// Entry point for the build script in your package.json
// import "@hotwired/turbo-rails"
// import * as bootstrap from "bootstrap"

import "./libs"
import "./template"
import "./functions"
import "./datatables"
import "./controllers"

document.addEventListener("DOMContentLoaded", function(){
  initializeJS()
})

window.initializeJS = function() {
  caller()
  initializeFlatPickr()
  initializeSelect2()
}